import React from "react";

export function Section({ title, children, testId }) {
  return (
    <section className="mt-12" data-testid={testId}>
      <h2 className="text-base md:text-lg font-semibold text-white mb-3 tracking-tight" style={{ fontFamily: "Outfit" }}>{title}</h2>
      <div className="space-y-4 text-slate-300 leading-relaxed">{children}</div>
    </section>
  );
}

export function Eyebrow({ children }) {
  return <div className="text-[10px] uppercase tracking-[0.25em] text-blue-300/80 mb-3">{children}</div>;
}

export function Outcomes({ items }) {
  return (
    <ul className="grid sm:grid-cols-2 gap-3 mt-2" data-testid="ceo-outcomes">
      {items.map(([stat, text]) => (
        <li key={stat} className="pc-card p-4" data-testid={`ceo-outcome-${stat.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}>
          <div className="text-2xl font-bold text-white" style={{ fontFamily: "Outfit" }}>{stat}</div>
          <div className="text-sm text-slate-400 mt-1 leading-relaxed">{text}</div>
        </li>
      ))}
    </ul>
  );
}

export function CeoPortrait() {
  return (
    <figure className="relative w-full max-w-[300px] mx-auto lg:mx-0" data-testid="ceo-portrait">
      <div className="relative">
        <div className="absolute inset-0 rounded-2xl border border-blue-500/40 translate-x-3 translate-y-3" aria-hidden="true" />
        <div className="relative rounded-2xl p-2 bg-gradient-to-br from-slate-200/90 to-slate-400/70 shadow-2xl shadow-blue-950/50">
          <img src="/uci-ceo.jpg" alt="Chief Executive Officer, Uplift Communications Incorporated"
            className="block w-full aspect-[406/640] object-cover rounded-xl" data-testid="ceo-portrait-img" />
        </div>
      </div>
      <figcaption className="mt-5 text-center lg:text-left">
        <div className="text-sm font-semibold text-white">Chief Executive Officer</div>
        <div className="text-xs text-slate-400">Uplift Communications Incorporated</div>
      </figcaption>
    </figure>
  );
}
